import { returnsLabel } from '../../../lib/reviewReturns.js';
import { ASSISTED_COPY, type AssistedCopy } from './assistedCopy.js';
import type { ReviewOutcome, ReviewPhase, ReviewRound } from './useCoachReview.js';


/**
 * Lo que dice la tarjeta del repaso en la vuelta sin mirar (Emmanuel, 15/10):
 * cuántos intentos quedan (3; un silencio no gasta), y al decidir, cuándo vuelve
 * de verdad (del server: 3, 7 o 16 días; aprendida tras 3 vueltas de memoria; al
 * 2.º o 3.º intento cuenta como bien sin subir de escalón).
 */
export function soloNote(
  s: {
    round: ReviewRound;
    phase: ReviewPhase;
    decided: boolean;
    triesLeft: number;
    silence: boolean;
    result:
      | { outcome: ReviewOutcome; nextReviewAt: string | null; retry?: boolean; learned?: boolean }
      | undefined;
  },
  now: Date = new Date(),
  /** Los textos del repaso (las palabras guardadas tienen los suyos: `reviewCopyFor`). */
  copy: AssistedCopy = ASSISTED_COPY.es,
): string | null {
  if (s.round !== 'solo') return null;
  if (s.phase === 'accepted' && s.result?.outcome === 'memoria') {
    if (s.result.learned) return copy.review.countsLearned;
    const when = returnsLabel(s.result.nextReviewAt, now);
    if (s.result.retry) return copy.review.countsRetry(when);
    return copy.review.countsKnown(when);
  }
  if (s.phase !== 'failed' && s.phase !== 'seen') return null;
  if (s.decided) return copy.review.countsAgain;
  if (s.phase === 'failed' && !s.silence) return copy.review.triesLeft(s.triesLeft);
  return null;
}
